import { AutogenModelDetentionProfile, AutogenRowDetentionProfile } from "./autogen/AutogenModelDetentionProfile";

export class ModelDetentionProfile extends AutogenModelDetentionProfile<RowDetentionProfile> {
	constructor() {
		super(RowDetentionProfile);
	}
}

export class RowDetentionProfile extends AutogenRowDetentionProfile {
}